import React, { useState } from 'react';

function Modal({ isOpen, onClose, onConfirm, title, message, confirmText = "Delete", cancelText = "Cancel" }) {
    const [isDeleting, setIsDeleting] = useState(false);

    if (!isOpen) return null;

    const handleConfirm = async () => {
        setIsDeleting(true);
        try {
            await onConfirm();
        } catch (error) {
            console.error("Error in confirmation:", error);
        } finally {
            setIsDeleting(false);
        }
    };

    return (
        <div 
            className="modal fade show" 
            style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
            onClick={isDeleting ? undefined : onClose}
        >
            <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{title || "Confirm Action"}</h5>
                        <button 
                            type="button" 
                            className="btn-close" 
                            onClick={isDeleting ? undefined : onClose}
                            disabled={isDeleting}
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="modal-body">
                        <p>{message || "Are you sure you want to perform this action?"}</p>
                    </div>
                    <div className="modal-footer">
                        <button 
                            type="button" 
                            className="btn btn-secondary" 
                            onClick={isDeleting ? undefined : onClose}
                            disabled={isDeleting}
                        >
                            {cancelText}
                        </button>
                        <button 
                            type="button" 
                            className="btn btn-danger" 
                            onClick={handleConfirm}
                            disabled={isDeleting}
                            style={isDeleting ? { opacity: 0.6, cursor: 'not-allowed' } : {}}
                        >
                            {isDeleting ? `${confirmText}...` : confirmText}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Modal;
